import {action, makeObservable, observable} from 'mobx';

import EventEmitter from '../../api/EventEmitter';
import {uint8ArrayToUuid} from '../../utils/arrayUtils';
import {AppStore} from '../AppStore';
import ITag from './ITag';
import TagEvent from './TagEvent';
import TagType from './TagType';

export class BaseTagsStore extends EventEmitter {
  constructor(public app: AppStore, public type: TagType) {
    super();
    makeObservable(this);
  }

  @observable loading = false;
  @observable isInit = false;

  @observable list: ITag[] = [];

  init = () => {
    if (this.loading || this.isInit) {
      return;
    }

    this.load();

    this.isInit = true;
  };

  @action setLoading = (loading: boolean) => {
    this.loading = loading;
  };

  @action setList = (list: ITag[]) => {
    this.list = list;
  };

  @action reset = () => {
    this.isInit = false;
    this.loading = false;
    this.list = [];
  };

  public load = () => {
    console.debug(`TODO: not implementre method "load"`);
  };

  @action protected processList = (tags: ITag[]) => {
    this.isInit = true;
    this.list = tags.map((tag) => ({...tag, type: this.type}));
  };

  public create = (name: string, color: string) => {
    console.debug(`TODO: not implementre method "create", args: ${name}, ${color}`);
    this.emit(TagEvent.CREATE_NEW_TAG, this);
  };

  protected processNewTag = (tag?: ITag | null) => {
    if (tag) {
      this.setList([...this.list, tag]);
    }
    this.load();
  };

  public update = (tag: ITag) => {
    console.debug(`TODO: not implementre method "update", args: ${tag}`);
    this.emit(TagEvent.UPDATE_TAG, this);
  };

  protected processEditedTag = (tag: ITag) => {
    console.debug(`TODO: not implementre method "processEditedTag", args: ${tag}`);
    this.load();
  };

  public delete = (tag: ITag) => {
    console.debug(`TODO: not implementre method "delete", args: ${tag}`);
    this.emit(TagEvent.DELETE_TAG, this);
  };

  protected processDeletedTag = (tag: ITag) => {
    console.debug(`TODO: not implementre method "processDeleteTag", args: ${tag}`);
    this.load();
  };

  public reorderTags = (tagIds: Uint8Array[]) => {
    console.debug(`TODO: not implementre method "updateOrdering", args: ${tagIds}`);
  };

  protected processReorderTags = (tagIds: Uint8Array[]) => {
    console.debug(`TODO: not implementre method "processReorderTags":`, tagIds.map((id) => uint8ArrayToUuid(id)));
    this.load();
  };
}

export default BaseTagsStore;
